export default __webpack_public_path__ + "static/media/tokio.e3cf9ffd.png";